import React from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";



/**
 * Минимальный прототип React-страницы с OpenStreetMap + две точки поверх карты. Используется Leaflet, 
 * так как он напрямую работает с OSM без ключей
 * 
 * @returns 
 */
export default function OsmPrototype() {
    var self = this;

    var ReactUseEffect = React.useEffect;
    var ReactUseRef = React.useRef;
    var mapRef = ReactUseRef(null);

    ReactUseEffect(function initMap() {
        if (mapRef.current !== null) {
            return;
        }

        // Создание карты
        var mapInstance = L.map("osm-map-container", {
            center: [51.1605, 71.4704], // Астана
            zoom: 6
        });

        mapRef.current = mapInstance;

        // Подложка OSM
        L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
            maxZoom: 19,
            attribution: "© OpenStreetMap contributors"
        }).addTo(mapInstance);

        // Headquarters
        var point1 = L.marker([51.147053, 71.371359]);
        point1.bindPopup("Headquarters");
        point1.addTo(mapInstance);

        // Karaganda Office
        var point2 = L.marker([49.811928, 73.102408]);
        point2.bindPopup("Karaganda Office");
        point2.addTo(mapInstance);

        // Semey Office
        var point3 = L.marker([50.408084, 80.241594]);
        point3.bindPopup("Semey Office");
        point3.addTo(mapInstance);

        // Immigration Services
        var point4 = L.marker([51.171086, 71.422557]);
        point4.bindPopup("Immigration Services");
        point4.addTo(mapInstance);
    }, []);

    return (
        React.createElement("div", {
            style: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column"
            }
        },
            React.createElement("div", {
                id: "osm-map-container",
                style: {
                    width: "100%",
                    height: "100%"
                }
            })
        )
    );
}
